

















import Vue from "vue";

// Vue components
import GlobalStatusInstallationChip from "@/views/App/Components/chips/GlobalStatusInstallationChip.vue";

// Model
import { getImageFromModel_200 } from "@/utility/Constants";
import { MachineContent } from "@/model/data/content/MachineContent";
import { MachineStatus } from "@/model/data/status/MachineStatus";
import { CleaningStatusTypeEnum } from "@/model/data/status/CleaningStatusTypeEnum";
import { InstallationStatusEnum } from "../../../../model/data/status/InstallationStatusEnum";
import VFaIcon from "@/components/VFaIcon.vue";
import { Machine } from "@/model/data/Machine";
import { CashTypeEnum } from "@/model/data/enums/CashTypeEnum";

export default Vue.extend({
    components: {
        GlobalStatusInstallationChip,
        VFaIcon,
    },
    data() {
        return {
            InstallationStatusEnum,
        };
    },
    props: ["installationSummaries"],
    computed: {
        installation() {
            if (this.installationSummaries != null && this.installationSummaries.length > 0) return this.installationSummaries[0];
            else return null;
        },

        isInLane() {
            return this.installation.machines.length > 0 && this.installation.machines[0].model && this.installation.machines[0].model.includes("InLane");
        },

        images() {
            let res = [];
            if (this.isInLane) res.push(this.getImageFromModel_200(this.installation.machines[0].model));
            else
                this.installation.machines.forEach((machine) => {
                    res.push(this.getImageFromModel_200(machine.model, machine.supportedCashType));
                });
            return res;
        },

        showThresholdAlert() {
            let res = false;
            if (this.installation.contentMachines != null) {
                this.installation.contentMachines.forEach((ms: MachineContent) => {
                    if (ms.thresholdAlerts != null && ms.thresholdAlerts.length > 0) res = true;
                });
            }
            return res;
        },

        showBacknotesIcon() {
            let res = false;
            if (this.installation.machines != null) {
                this.installation.machines
                    .filter((m: Machine) => m.supportedCashType == CashTypeEnum.Banknote)
                    .forEach((m: Machine) => {
                        if (this.installation.contentMachines != null) {
                            this.installation.contentMachines
                                .filter((ms: MachineContent) => ms.machineSerialNumber == m.serialNumber)
                                .forEach((ms: MachineContent) => {
                                    if (ms.thresholdAlerts != null && ms.thresholdAlerts.length > 0) res = true;
                                });
                        }
                    });
            }
            return res;
        },

        showCoinsIcon() {
            let res = false;
            if (this.installation.machines != null) {
                this.installation.machines
                    .filter((m: Machine) => m.supportedCashType == CashTypeEnum.Coin)
                    .forEach((m: Machine) => {
                        if (this.installation.contentMachines != null) {
                            this.installation.contentMachines
                                .filter((ms: MachineContent) => ms.machineSerialNumber == m.serialNumber)
                                .forEach((ms: MachineContent) => {
                                    if (ms.thresholdAlerts != null && ms.thresholdAlerts.length > 0) res = true;
                                });
                        }
                    });
            }
            return res;
        },

        showNeedCleaning() {
            let res = false;
            if (this.installation.statusMachines != null) {
                this.installation.statusMachines.forEach((ms: MachineStatus) => {
                    if (ms.cleaningStatus == CleaningStatusTypeEnum.Necessary) res = true;
                });
            }
            return res;
        },

        backgroundColor() {
            if (this.showThresholdAlert || this.showNeedCleaning) return "warning lighten-3";
            switch (this.installation.status as InstallationStatusEnum) {
                case InstallationStatusEnum.Warning:
                    return "warning lighten-3";
                case InstallationStatusEnum.Blocked:
                case InstallationStatusEnum.PartiallyBlocked:
                    return "error lighten-3";
                default:
                    return null;
            }
        },
    },
    methods: { getImageFromModel_200 },
});
